module.exports = __webpack_public_path__ + "plan-2.png";